import skills from '../database/skills'

const getSkills = () => {
  return skills;
}

export default getSkills;